import * as THREE from 'three';
import { firstDinoOnRay, type BowFireCtx, type BowTarget } from './Bow';

export const SLING_DAMAGE = 8;
export const SLING_RANGE = 10;
export const SLING_RECOVER_S = 0.45;

export class Sling {
  recover = 0;
  fired = 0;

  tick(dt: number): void {
    if (!Number.isFinite(dt) || dt <= 0) {
      return;
    }
    this.recover = Math.max(0, this.recover - dt);
  }

  drive(dt: number, attack: boolean, ctx: BowFireCtx): boolean {
    this.tick(dt);
    return attack ? this.tryFire(ctx) : false;
  }

  tryFire(ctx: BowFireCtx): boolean {
    if (ctx.held !== 'sling' || this.recover > 0) {
      return false;
    }
    this.recover = SLING_RECOVER_S;
    this.fired += 1;
    firstSlingOnRay(ctx.dinos, ctx.camera, ctx.yaw)?.takeHit(SLING_DAMAGE);
    return true;
  }
}

export function firstSlingOnRay(
  dinos: readonly BowTarget[],
  camera: THREE.Camera,
  yaw?: number,
  range = SLING_RANGE,
): BowTarget | null {
  return firstDinoOnRay(dinos, camera, yaw, range);
}
